// extracted by mini-css-extract-plugin
export default {"root":"spinner_root__x+kme","uiSpinnerRotate":"spinner_uiSpinnerRotate__KWNWp","small":"spinner_small__yZdQl","regular":"spinner_regular__8zfqL","large":"spinner_large__9jRPW"};